// 与app关联部分
import Vue from "vue";
import { xztokenExchange } from "../service/getData";
import { Toast } from "mint-ui";
import getUa from "../utils/getUa";
var appfrm = document.createElement("iframe");
appfrm.height = "0";
appfrm.width = "0";
appfrm.style.display = "none";
appfrm.id = "xzappFrmops";
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(appfrm, s);
const _this = Vue.prototype;
const state = getUa.userAgent;
const xz_serialize = function(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};
var xzappLoadFrame = function(url) {
  // 兼容社交软件打开
  if (getUa.userAgent.issocialapp) {
    location.href = "/openinbrowser.html?openurl=" + encodeURIComponent(url);
    return false;
  }
  if (
    getUa.userAgent.isiphone &&
    navigator.userAgent.indexOf("Safari") > -1 &&
    navigator.userAgent.indexOf("Chrome") == -1
  ) {
    location.href = url;
  } else if (
    getUa.userAgent.isandroid &&
    navigator.userAgent.indexOf("Chrome") > -1 &&
    navigator.userAgent.indexOf("Safari") > -1
  ) {
    location.href = url;
  } else {
    appfrm.src = "";
    appfrm.src = url;
  }
};
export const confirmAddress = function(datas, dealType, thats) {
  console.log(this);
  var res = JSON.parse(datas);
  if (dealType === "exchange") {
    if (res && res.userAddressId) {
      thats.dealgoods(dealType, res.userAddressId);
    } else {
      Toast("请选择兑换地址");
    }
  } else {
    if (res && res.userAddressId && this.isWin === true) {
      thats.updateintegralorderaddress(thats.winningOrderId, res.userAddressId);
    } else {
      thats.dealgoods(dealType, 0);
    }
  }
};
// 公共方法
Vue.prototype.registerIosWebView = function(op, func) {
  _this.setBridge(function(bridge) {
    bridge.registerHandler(op, function(data, responseCallback) {
      responseCallback(true);
    });
  });
};
Vue.prototype.callIosFunc = function(op, content) {
  _this.setBridge(function(bridge) {
    bridge.callHandler(op, content);
  });
};
Vue.prototype.setBridge = function(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement("iframe");
  WVJBIframe.style.display = "none";
  WVJBIframe.src = "wvjbscheme://__BRIDGE_LOADED__";
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function() {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
};
Vue.prototype.checkVersion = function() {
  return true;
};
Vue.prototype.setIosWebView = function(datas) {
  var op = datas.op;
  var params = datas.params;
  _this.setBridge(function(bridge) {
    bridge.callHandler(op, params, function(response) {
      if (response) {
        response = JSON.parse(response);
        _this.webView.response = response;
        var statusBarHeight = response.statusBarHeight ? response.statusBarHeight+ 'px':'35px';
        _this.setAppStore("statusBarHeight", statusBarHeight);
        _this.webView.version = response.appVersion || _this.webView.version;
      }
    });
  });
};
Vue.prototype.setAndroidWebView = function(datas) {
  var jsparams_json = JSON.stringify(datas);
  if (typeof AJavaScriptInterface != "undefined") {
    var rst = AJavaScriptInterface.startIntentToActivity(jsparams_json);
    if (rst && typeof rst === 'string') {
      rst = JSON.parse(rst);
      _this.webView.response = rst;
      var statusBarHeight = rst.statusBarHeight ? rst.statusBarHeight+ 'px':'35px';
      _this.setAppStore("statusBarHeight", statusBarHeight);
      _this.webView.version = rst.appVersion || _this.webView.version;
    }
  }
};
Vue.prototype.setWebView = function(datas) {
  if (state.isxzapp_ios) {
    _this.setIosWebView(datas);
  } else if (state.isxzapp_android) {
    _this.setAndroidWebView(datas);
  } else {
  }
};
Vue.prototype.open = function(datas) {
  if (state.isxzapp_ios) {
    _this.setIosWebView(datas);
  } else if (state.isxzapp_android) {
    _this.setAndroidWebView(datas);
  } else {
  }
};
Vue.prototype.openApps = function(op, params) {
  var channels = _this.getStore("referrerStatistics");
  if (channels != null) {
    params.channels = channels;
  }
  xzappLoadFrame("openapp.xzdz://xiaozhu/" + op + "?" + xz_serialize(params));
};

// 直接开启app
Vue.prototype.openApp = {
  login: function() {
    var xztoken = _this.getUrlParms("xztoken");
    if (xztoken && !xz.sess.islogin && xz.os.isxzapp) {
      xz.api.user.xztokenExchange(xztoken, "xiaozhu.app.writeLoginDatas");
      xztokenExchange(xztoken).then(response => {
        if (response.status == 200) {
          xz.sess.login(datas.content);
          sessionStorage.setItem("login", 1);
          refreshHeaders();
          bindHeaders();
        }
      });
    }
  },
  shareContent: function(action, channel, objId) {
    _this.openApp("shareContent", {
      channel: channel,
      action: action,
      objId: objId
    });
  },
  simpleShare: function(
    shareUrl,
    shareContent,
    title,
    desc,
    image,
    site,
    thumb
  ) {
    _this.openApp("SimpleShare", {
      channel: "",
      shareUrl: shareUrl,
      shareContent: shareContent,
      title: title,
      desc: desc,
      image: image,
      thumb: thumb || "http://m.xiaozhu.com/images/xiaozhu_ios_a.png"
    });
  },
  openMy: function() {
    _this.openApp("openpage", {
      page: "my"
    });
  },
  openMyFD: function() {
    _this.openApp("openpage", {
      page: "myFD"
    });
  },
  openIndex: function() {
    _this.openApp("openpage", {
      page: "index"
    });
  },
  openInvite: function() {
    _this.openApp("openpage", {
      page: "invite"
    });
  },
  openTobelandlord: function() {
    _this.openApp("openpage", {
      page: "tobelandlord"
    });
  },
  openOrderList: function() {
    _this.openApp("openpage", {
      page: "orderList"
    });
  },
  openOrderDetail: function(bookOrderId) {
    _this.openApp("openpage", {
      page: "orderDetail",
      bookOrderId: bookOrderId
    });
  },
  openAppPage: function(page, params) {
    const param = Object.assign({}, params, {
      page: page
    });
    _this.openApp("openpage", param);
  },
  openImOrderDetail: function() {
    _this.openApp("openpage", {
      page: "orderDetailDirectPush",
      bookOrderId: bookOrderId
    });
  },
  openOrderBook: function(luId, checkInDay, checkOutDay) {
    _this.openApp("openpage", {
      page: "orderBook",
      luId: luId,
      checkInDate: checkInDay,
      checkOutDate: checkOutDay
    });
  },
  openMsgList: function() {
    _this.openApp("openpage", {
      page: "msgList"
    });
  },
  openCommentList: function() {
    _this.openApp("openpage", {
      page: "commentList"
    });
  },
  openDetail: function(luid) {
    _this.openApp("openpage", {
      page: "detail",
      luid: luid
    });
  },
  openRegister: function(mobile, invitecode) {
    _this.openApp("openpage", {
      page: "register",
      invitecode: invitecode || "",
      mobile: mobile || ""
    });
  },
  openLogin: function(mobile) {
    _this.openApp("openpage", {
      page: "login",
      mobile: mobile || ""
    });
  },
  openSearch: function(cityId, cityName) {
    _this.openApp("openpage", {
      page: "search",
      cityId: cityId,
      cityName: cityName
    });
  },
  openLandlordInfo: function(luid, landlordId) {
    _this.openApp("openpage", {
      page: "landlordInfo",
      luid: luid,
      landlordId: landlordId
    });
  },
  openWebview: function(url) {
    _this.openApp("openpage", {
      page: "webview",
      url: url
    });
  },
  openSystemBrowser: function(url) {
    _this.openApp("openpage", {
      page: "systemBrowser",
      url: url
    });
  },
  openCleanService: function() {
    _this.openApp("openpage", {
      page: "cleanService"
    });
  }
};
// 调用方法 this.webView.openMy();

// 设置webview
Vue.prototype.webView = {
  baseVersion: "30500",
  version: "",
  getAllValue: function(datas) {
    var datas = {
      op: "getValue",
      opDesc: "获取指定值",
      params: {
        optName: ["clipboard", "appVersion", "uniqueId", "userInfo", "statusBarHeight"]
      }
    };
    _this.setWebView(datas);
  },
  getVersion: function() {
    if (_this.webView.version) return _this.webView.version;
    var datas = {
      op: "getValue",
      opDesc: "获取指定值",
      params: {
        optName: ["appVersion"]
      }
    };
    _this.setWebView(datas);
    return _this.webView.version;
  },
  getClipboard: function() {
    var datas = {
      op: "getValue",
      opDesc: "获取指定值",
      params: {
        optName: ["clipboard"]
      }
    };
    _this.setWebView(datas);
  },
  getUniqueId: function() {
    var datas = {
      op: "getValue",
      opDesc: "获取指定值",
      params: {
        optName: ["uniqueId"]
      }
    };
    x_this.setWebView(datas);
  },
  getUserInfo: function() {
    var datas = {
      op: "getValue",
      opDesc: "获取指定值",
      params: {
        optName: ["userInfo"]
      }
    };
    _this.setWebView(datas);
  },
  setDefaultShareConfig: function(
    shareTitle,
    shareUrl,
    shareContent,
    imageUrl,
    shareBigImg,
    channel,
    vxData
  ) {
    // if (state.iswechat) {
    //   xz.shareTool.setWechatShare(shareTitle,shareUrl,shareContent,imageUrl);
    // } else
    if (state.isxzapp) {
      _this.webView.setShare(
        shareUrl,
        shareContent,
        shareTitle,
        shareContent,
        imageUrl,
        shareUrl,
        imageUrl,
        "",
        "",
        true,
        shareBigImg,
        channel,
        vxData
      );
    }
  },
  setShare: function(
    shareUrl,
    shareContent,
    shareTitle,
    desc,
    image,
    site,
    thumb,
    callBackFunc,
    appShare,
    hideOther,
    shareBigImg
  ) {
    var datas = {
      op: "setValue",
      opDesc: "设置指定值 - 分享",
      params: {
        type: "shareInfo",
        vals: [
          {
            opt: "shareTitle",
            val: shareTitle
          },
          {
            opt: "shareLink",
            val: shareUrl
          },
          {
            opt: "shareIcon",
            val: thumb || "http://m.xiaozhu.com/images/logo.png"
          },
          {
            opt: "shareImg",
            val: image
          },
          {
            opt: "shareContent",
            val: shareContent
          },
          {
            opt: "shareDesc",
            val: desc
          },
          {
            opt: "hideOtherChannel",
            val: hideOther ? "yes" : "no"
          },
          {
            opt: "shareBigImg",
            val: shareBigImg || ""
          }
        ]
      }
    };
    if (appShare) {
      datas.params.vals.push({
        opt: "action",
        val: appShare.action
      });
      datas.params.vals.push({
        opt: "objId",
        val: appShare.objId
      });
    }
    if (callBackFunc) {
      if (state.isxzapp_ios) {
        _this.registerIosWebView("shareCallback", callBackFunc);
      } else {
        datas.params.vals.push({
          opt: "shareCallback",
          val: callBackFunc
        });
      }
    }
    _this.setWebView(datas);
  },

  // 控制分享渠道shareChannel:[sinaweibo,qqzone,weixin,friendcircle,qq,other] ，传空时默认都有
  // shareContent 和  shareDesc  是简洁和详细
  // shareIcon 和 shareImg  是缩略图和大图
  // shareBigImg 为 shareChannel含有 other 时的保存图片url
  setNewShare: function(
    shareUrl,
    shareContent,
    shareTitle,
    desc,
    image,
    shareChannel,
    shareBigImg,
    thumb,
    callBackFunc,
    appShare,
    vxData
  ) {
    var datas = {
      op: "setValue",
      opDesc: "设置指定值 - 分享",
      params: {
        type: "shareInfo",
        vals: [
          {
            opt: "shareTitle",
            val: shareTitle
          },
          {
            opt: "shareLink",
            val: shareUrl
          },
          {
            opt: "shareIcon",
            val: thumb || "http://m.xiaozhu.com/images/logo.png"
          },
          {
            opt: "shareImg",
            val: image
          },
          {
            opt: "shareContent",
            val: shareContent
          },
          {
            opt: "shareDesc",
            val: desc
          },
          {
            opt: "shareBigImg",
            val: shareBigImg || ""
          },
          {
            opt: "shareChannel",
            val: shareChannel.join("|")
          }
        ]
      }
    };
    if (appShare) {
      datas.params.vals.push({
        opt: "action",
        val: appShare.action
      });
      datas.params.vals.push({
        opt: "objId",
        val: appShare.objId
      });
      // datas.params.vals.push({'opt': 'shareInvite', 'val': appShare.shareInvite});
    }
    if (vxData) {
      console.log('vxData',vxData)
      datas.params.vals.push({
        opt: "shareMiniProgramId",
        val: vxData.miniProgramId
      });
      datas.params.vals.push({
        opt: "shareMiniProgramPath",
        val: vxData.miniProgramPath
      });
      datas.params.vals.push({
        opt: "shareMiniProgramOpen",
        val: vxData.miniProgramOpen
      });
    }
    if (callBackFunc) {
      if (state.isxzapp_ios) {
        _this.registerIosWebView("shareCallback", callBackFunc);
      } else {
        datas.params.vals.push({
          opt: "shareCallback",
          val: callBackFunc
        });
      }
    }
    _this.setWebView(datas);
  },

  openMy: function() {
    if (!_this.checkVersion()) {
      _this.openApp.openMy();
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "房客中心",
      params: {
        page: "my"
      }
    };
    _this.setWebView(params);
  },
  openMyFD: function() {
    if (!_this.checkVersion()) {
      _this.openApp.openMyFD();
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "房东中心",
      params: {
        page: "myFD"
      }
    };
    _this.setWebView(params);
  },
  openIndex: function() {
    if (!_this.checkVersion()) {
      _this.openApp.openIndex();
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "打开app首页",
      params: {
        page: "index"
      }
    };
    _this.setWebView(params);
  },
  openInvite: function() {
    if (!_this.checkVersion()) {
      _this.openApp.openInvite();
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "邀请分享",
      params: {
        page: "invite"
      }
    };
    _this.setWebView(params);
  },
  openTobelandlord: function() {
    if (!_this.checkVersion()) {
      _this.openApp.openTobelandlord();
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "成为房东",
      params: {
        page: "tobelandlord"
      }
    };
    _this.setWebView(params);
  },
  openOrderList: function(destroyRefer) {
    if (!_this.checkVersion()) {
      _this.openApp.openOrderList();
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "订单列表",
      params: {
        page: "orderList"
      }
    };
    if (destroyRefer) params.params['destroyRefer'] = destroyRefer
    _this.setWebView(params);
  },
  openOrderDetail: function(bookOrderId) {
    if (!_this.checkVersion()) {
      _this.openApp.openOrderDetail(bookOrderId);
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "订单详情",
      params: {
        page: "orderDetail",
        bookOrderId: bookOrderId
      }
    };
    _this.setWebView(params);
  },
  openAppPage: function(pageName, param) {
    // params = {
    //     op: 操作 openpage,
    //     opDesc: '', 描述
    //     params: { page: page } 需要参数
    // };
    // pageName:页面名称 String, desc: 页面描述, param:所需参数
    if (!_this.checkVersion()) {
      _this.openApp.openAppPage(pageName, param);
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "",
      params: Object.assign({}, param, {
        page: pageName
      })
    };
    _this.setWebView(params);
  },
  openImOrderDetail: function(bookOrderId) {
    if (!_this.checkVersion()) {
      _this.openApp.openImOrderDetail(bookOrderId);
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "订单详情",
      params: {
        page: "orderDetailDirectPush",
        bookOrderId: bookOrderId
      }
    };
    _this.setWebView(params);
  },
  openOrderBook: function(luId, checkInDay, checkOutDay) {
    var params = {
      op: "openPage",
      opDesc: "",
      params: {
        page: "orderBook",
        luId: luId,
        checkInDate: checkInDay,
        checkOutDate: checkOutDay
      }
    };
    _this.setWebView(params);
  },
  openNewPage: function(urls) {
    var params = {
      op: "openPage",
      opDesc: "",
      params: {
        page: "webview",
        url: urls
      }
    };
    _this.setWebView(params);
  },
  openMsgList: function() {
    if (!_this.checkVersion()) {
      _this.openApp.openMsgList();
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "消息列表",
      params: {
        page: "msgList"
      }
    };
    _this.setWebView(params);
  },
  openCommentList: function() {
    if (!_this.checkVersion()) {
      _this.openApp.openCommentList();
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "点评列表",
      params: {
        page: "commentList"
      }
    };
    _this.setWebView(params);
  },
  openDetail: function(luId, startDate, endDate) {
    var startDate = startDate || "";
    var endDate = endDate || "";
    if (!_this.checkVersion()) {
      _this.openApp.openDetail(luId);
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "房间详情",
      params: {
        page: "detail",
        luid: luId,
        startDate: startDate,
        endDate: endDate,
        finishSelf: false
      }
    };
    _this.setWebView(params);
  },
  openRegister: function(mobile, invitecode) {
    if (!_this.checkVersion()) {
      _this.openApp.openRegister(mobile, invitecode);
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "注册",
      params: {
        page: "register",
        invitecode: invitecode || "",
        mobile: mobile || ""
      }
    };
    _this.setWebView(params);
  },
  openLogin: function(mobile) {
    if (!_this.checkVersion()) {
      _this.openApp.openLogin(mobile);
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "登录",
      params: {
        page: "login",
        mobile: mobile || ""
      }
    };
    _this.setWebView(params);
  },
  openSearch: function(
    cityId,
    cityName,
    abroad,
    checkInDay,
    checkOutDay,
    leaseType,
    minPrice,
    maxPrice,
    distId,
    distName,
    locId,
    locName,
    keyWord,
    huXing,
    facilitys,
    guestNum,
    orderBy,
    lat,
    lng,
    radius,
    lodgeUnitTags,
    searchNearby,
    timeZone,
    searchFrom
  ) {
    if (!_this.checkVersion()) {
      _this.openApp.openSearch(cityId, cityName);
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "城市搜索",
      params: {
        page: "search",
        cityId: cityId,
        cityName: cityName,
        abroad: abroad || 0,
        checkInDay: checkInDay || "",
        checkOutDay: checkOutDay || "",
        leaseType: leaseType || "",
        minPrice: minPrice || "",
        maxPrice: maxPrice || "",
        distId: distId || "",
        distName: distName || "",
        locId: locId || "",
        locName: locName || "",
        keyword: keyWord || "",
        huXing: huXing || "",
        facilitys: facilitys || "",
        guestNum: guestNum || "",
        orderBy: orderBy || "",
        latitude: lat || "",
        longitude: lng || "",
        radius: radius || "",
        lodgeUnitTags: lodgeUnitTags || "",
        searchNearby: searchNearby ? 1 : 0,
        timeZone: timeZone || "",
        searchFrom: searchFrom || "" // suggestion
      }
    };
    _this.setWebView(params);
  },
  openLandlordInfo: function(luId, landlordId) {
    if (!_this.checkVersion()) {
      _this.openApp.openLandlordInfo(luId, landlordId);
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "房东详情",
      params: {
        page: "landlordInfo",
        luid: luId,
        landlordId: landlordId
      }
    };
    _this.setWebView(params);
  },
  openWebview: function(url) {
    if (!_this.checkVersion()) {
      _this.openApp.openWebview(url);
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "webView打开链接",
      params: {
        page: "webview",
        url: url
      }
    };
    _this.setWebView(params);
  },
  openSystemBrowser: function(url) {
    if (!_this.checkVersion()) {
      _this.openApp.openSystemBrowser(url);
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "系统浏览器打开链接",
      params: {
        page: "systemBrowser",
        url: url
      }
    };
    _this.setWebView(params);
  },
  openCleanService: function(url) {
    if (!_this.checkVersion()) {
      _this.openApp.openCleanService(url);
      return false;
    }
    var params = {
      op: "openPage",
      opDesc: "保洁申请",
      params: {
        page: "cleanService",
        url: url
      }
    };
    _this.setWebView(params);
  },
  openLodgeComment: function(luId) {
    var params = {
      op: "openPage",
      opDesc: "房间点评",
      params: {
        page: "lodgeComment",
        luid: luId
      }
    };
    _this.setWebView(params);
  },
  openBackHotel: function() {
    var params = {
      op: "click",
      opDesc: "酒店详情回退",
      params:{
        type: "hotelback",
      }

    };
    _this.setWebView(params);
  },
  openBack: function() {
    var params = {
      op: "click",
      opDesc: "回退",
      type: "appback"
    };
    _this.setWebView(params);
  },
  openClose: function() {
    var params = {
      op: "click",
      opDesc: "关闭",
      params: {
        type: "popPageClose"
      }
    };
    _this.setWebView(params);
  },
  openFdComment: function(landlordId) {
    var params = {
      op: "openPage",
      opDesc: "房东点评",
      params: {
        page: "landlordComment",
        landlordId: landlordId
      }
    };
    _this.setWebView(params);
  },
  openRealAuth: function() {
    var params = {
      op: "openPage",
      opDesc: "实名认证",
      params: {
        page: "realNameVerify"
      }
    };
    _this.setWebView(params);
  },
  openWechat: function() {
    var params = {
      op: "openPage",
      opDesc: "打开微信",
      params: {
        page: "wechat"
      }
    };
    _this.setWebView(params);
  },
  setClipboard: function(content) {
    var params = {
      op: "setValue",
      opDesc: "设置指定值 - 剪贴板",
      params: {
        type: "webView",
        vals: [
          {
            opt: "clipboard",
            val: content
          }
        ]
      }
    };
    _this.setWebView(params);
  },
  setPhone: function(phone) {
    var params = {
      op: "setValue",
      opDesc: "设置指定值 - 剪贴板",
      params: {
        type: "webView",
        vals: [
          {
            opt: "callPhone",
            val: phone
          }
        ]
      }
    };
    _this.setWebView(params);
  },
  setConfig: function(share, copy, browser) {
    var params = {
      op: "setValue",
      opDesc: "设置",
      params: {
        type: "webView",
        vals: [
          {
            opt: "allowCopy",
            val: copy ? "true" : "false"
          },
          {
            opt: "allowOpenInBrowser",
            val: browser ? "true" : "false"
          },
          {
            opt: "allowShare",
            val: share ? "true" : "false"
          }
        ]
      }
    };
    _this.setWebView(params);
  },
  openShare: function() {
    var params = {
      op: "openShare"
    };
    _this.setWebView(params);
  },
  openUserAddress: function() {
    var params = {
      op: "openPage",
      opDesc: "收件地址",
      params: {
        page: "recipidntsAddrdsses",
        returnFunctionName: "confirmAddress"
      }
    };
    _this.setWebView(params);
  },
  openPicDetail: function(imgs, current) {
    var params = {
      op: "openPage",
      opDesc: "图片预览",
      params: {
        page: "picDetail",
        values: imgs,
        current: current
      }
    };
    _this.setWebView(params);
  },
  openCoupon: function() {
    var params = {
      op: "openPage",
      opDesc: "打开代金券列表",
      params: {
        page: "couponList"
      }
    };
    _this.setWebView(params);
  },
  openCouponDetail: function(accountId) {
    var params = {
      op: "openPage",
      opDesc: "打开代金券列表",
      params: {
        page: "couponDetail",
        accountId: accountId
      }
    };
    _this.setWebView(params);
  },
  openCleanServiceCouponList: function() {
    var params = {
      op: "openPage",
      opDesc: "打开保洁代金券列表",
      params: {
        page: "cleanServiceCouponList"
      }
    };
    _this.setWebView(params);
  },
  openCleanServiceCouponDetail: function(accountId) {
    var params = {
      op: "openPage",
      opDesc: "打开保洁代金券详情",
      params: {
        page: "cleanServiceCouponDetail",
        accountId: accountId
      }
    };
    _this.setWebView(params);
  },
  openPostageCouponList: function() {
    var params = {
      op: "openPage",
      opDesc: "打开邮费抵扣券列表",
      params: {
        page: "postageCouponList"
      }
    };
    _this.setWebView(params);
  },
  openPostageCouponDetail: function(accountId) {
    var params = {
      op: "openPage",
      opDesc: "打开邮费抵扣券详情",
      params: {
        page: "postageCouponDetail",
        accountId: accountId
      }
    };
    _this.setWebView(params);
  },
  openMyCoupon: function() {
    var params = {
      op: "openPage",
      opDesc: "打开我的代金券首页",
      params: {
        page: "myCoupon"
      }
    };
    _this.setWebView(params);
  },
  openNoticesFdList: function() {
    var params = {
      op: "openPage",
      opDesc: "打开房东通知列表",
      params: {
        page: "noticesFdList"
      }
    };
    _this.setWebView(params);
  },
  openNoticesFkList: function() {
    var params = {
      op: "openPage",
      opDesc: "打开房客通知列表",
      params: {
        page: "noticesFkList"
      }
    };
    _this.setWebView(params);
  },
  openOtherApp: function(openUrl, failedTips) {
    var params = {
      op: "openotherapp",
      opDesc: "打开外部app",
      params: {
        openurl: openUrl,
        failedtips: failedTips
      }
    };
    _this.setWebView(params);
  },
  openBookOrderPay: function() {
    var params = {
      op: "openPage",
      opDesc: "打开支付页",
      params: {
        page: "pay",
        bizsource: "firstcheckin",
        bookorderid: "13377888"
      }
    };
    _this.setWebView(params);
  },
  openBusiUserIdentify: function(skipIndex) {
    var params = {
      op: "openPage",
      opDesc: "打开商旅认证页",
      params: {
        page: "busiTravelUserIdentify",
        skipIndex: skipIndex
      }
    };
    _this.setWebView(params);
  },
  setBusiUserIdentify: function(state) {
    var params = {
      op: "setValue",
      opDesc: "更新商旅认证状态缓存",
      params: {
        type: "webView",
        vals: [
          {
            opt: "busiTravelUserIdentifyState",
            val: state
          }
        ]
      }
    };
    _this.setWebView(params);
  },
  updateZhimaScore: function(score) {
    var params = {
      op: "setValue",
      opDesc: "更新芝麻分缓存",
      params: {
        type: "webView",
        vals: [
          {
            opt: "updateZhimaScore",
            val: score
          }
        ]
      }
    };
    _this.setWebView(params);
  },
  openLandlordFlashBookManage: function() {
    var params = {
      op: "openPage",
      opDesc: "打开房东速订管理",
      params: {
        page: "landlordFlashBookManage"
      }
    };
    _this.setWebView(params);
  },
  openActivityFeeSubmit: function(
    type,
    activityId,
    title,
    callBackUrl,
    closeSelf,
    waitingButtonName,
    payObjList
  ) {
    var returnurl = callBackUrl || "";
    var closeSelfarg = closeSelf || false;
    var waitingButtonNamearg = waitingButtonName || "查看订单";
    var params = {};
    if (type == "activityFee") {
      params = {
        op: "openPay",
        opDesc: "活动支付_跳转",
        params: {
          objType: type,
          objId: activityId,
          title: title,
          returnUrl: returnurl,
          closeSelf: closeSelfarg,
          waitingButtonName: waitingButtonNamearg
        }
      };
    } else {
      params = {
        op: "openPay",
        opDesc: "支付_跳转",
        params: {
          payObjList: payObjList,
          title: title,
          returnUrl: returnurl,
          closeSelf: closeSelfarg,
          waitingButtonName: waitingButtonNamearg
        }
      };
    }
    _this.setWebView(params);
  },
  openLandlordMallSalegGoodsDetail: function(goodsId) {
    var params = {
      op: "openPage",
      opDesc: "房东商城商品详情页",
      params: {
        page: "landlordMallSalegGoodsDetail",
        goodsId: goodsId
      }
    };
    _this.setWebView(params);
  },
  androidOpenBack: function() {
    var params = {
      op: "click",
      opDesc: "回退",
      params: {
        type: "appback"
      }
    };
    _this.setWebView(params);
  },
  openSearchDest: function() {
    var params = {
      op: "openPage",
      opDesc: "搜索目的地页",
      params: {
        page: "destinationPage"
      }
    };
    _this.setWebView(params);
  },
  openMyIndex: function() {
    var params = {
      op: "openPage",
      opDesc: "我的资料页",
      params: {
        page: "userInfoDetail"
      }
    };
    _this.setWebView(params);
  },
  openTenantReview: function() {
    var params = {
      op: "openPage",
      opDesc: "房客点评列表页",
      params: {
        page: "commentList"
      }
    };
    _this.setWebView(params);
  },
  openAccountIndex: function() {
    var params = {
      op: "openPage",
      opDesc: "账户页",
      params: {
        page: "accountNumSetting"
      }
    };
    _this.setWebView(params);
  },
  openRocBusiTravel: function() {
    var params = {
      op: "openPage",
      opDesc: "商旅介绍页",
      params: {
        page: "busitravel"
      }
    };
    _this.setWebView(params);
  },
  chooseBillBack:function(billvId){
    var params = {
      op: "billSwitch",
      opDesc: "选择发票返回",
      params: {
        billvId: billvId || ''
      }
    };
    _this.setWebView(params);
  },
  openPayBills: function(objParams) {
    var returnurl = objParams.returnurl;
    var closeSelfarg = false;
    var waitingButtonNamearg = "返回订单详情";
    const title = "发票提交成功";
    const params = {
      op: "openPay",
      opDesc: title,
      params: {
        isNew: true,
        payObjList: objParams.payObjList,
        title: title,
        returnUrl: returnurl,
        closeSelf: closeSelfarg,
        waitingButtonName: waitingButtonNamearg,
        isBill: true,
        orderId: objParams.orderId
      }
    };
    console.log("params", params);
    _this.setWebView(params);
  },
  openCreatefdCoupon: function() {
    var params = {
      op: "openPage",
      opDesc: "创建代金券页",
      params: {
        page: "createfdCoupon"
      }
    };
    _this.setWebView(params);
  },
  openPublishPriceRule: function(data) {
    let { desc, type, title} = data
    var params = {
      op: "openPage",
      opDesc: "房客退订规则",
      params: {
        page: "publishPriceRule",
        desc,
        type,
        title
      }
    };
    _this.setWebView(params);
  },
  openRpPirceRule: function(data) {
    let { desc, type, title} = data
    var params = {
      op: "openPage",
      opDesc: "房客退订规则",
      params: {
        page: "rpPriceRule",
        desc,
        type,
        title
      }
    };
    _this.setWebView(params);
  },
  openActionRecords: function(activityId) {
    var params = {
      op: "openPage",
      opDesc: "报名记录",
      params: {
        page: "actionRecords",
        activityId: activityId
      }
    };
    _this.setWebView(params);
  },
  // H5通知APP是否实名验证通过
  broadcastSetRealName: function(isSuccessVerify) {
    var params = {
      op: "setValue",
      opDesc: "实名验证",
      params: {
        type: "webView",
        vals: [
          {
            opt: "isSuccessVerify",
            val: isSuccessVerify
          }
        ]
      }
    };
    _this.setWebView(params);
  },
  // H5通知APP 取消订单 原因参数
  broadcastSetReason: function(url, orderId, useFreeCancel, cancelSource, cancelType, cancelReason, cancelReasonDetail, parentOrderId, from) {
    var params = {
      op: "openPage",
      opDesc: "取消原因",
      params: {
        page: "orderWebview",
        url: url, // 跳转链接
        orderId: orderId,
        useFreeCancel: useFreeCancel, // 是否使用免费取消
        cancelSource: cancelSource,  // 一级取消类型
        cancelType:cancelType,  // 取消类型 （二级取消类型）
        cancelReason: cancelReason, // 取消原因（二级取消原因）
        cancelReasonDetail: cancelReasonDetail, // 三级取消原因
        parentOrderId: parentOrderId,
        from: from // 来源
      }
    };
    _this.setWebView(params);
  },
  openWeChatMiniApps: function (data) {
    var params = {
      op: "openPage",
      opDesc: data.desc,
      params: {
        page: 'WeChatMiniApps',
        userName : data.userName, // 小程序标识 
        path : data.path, // 跳转路径
        type : data.type // 0 正式
      }
    };
    console.log(params)
    _this.setWebView(params);
  }
};

/**
 * 存储localStorage
 */
Vue.prototype.setAppStore = function(name, content) {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};



// WEBPACK FOOTER //
// ./src/utils/openApp.js